import { Formik } from 'formik';
import { toast } from 'react-hot-toast';

import http from 'src/api/endpoints';
import { Button, TextInput } from 'src/components';
import AuthContainer from 'src/Containers/AuthContainer';
import { enterEmailValidationSchema } from './validation';
import OnboardingHeaderWrapper from 'src/components/Wrapper/OnboardingHeaderWrapper';
import useLoading from 'src/hooks/useLoading';
import { PARENT_URL } from 'src/config/parentURL';

interface SubmitValues {
  email: string;
}

type EnterEmailData = {
  email: string;
  nextStep: any;
};

type EnterEmailProps = EnterEmailData & {
  updateFields: (fields: Partial<EnterEmailData>) => void;
  nextStep: () => void;
};

const EnterEmail = ({ nextStep, updateFields }: EnterEmailProps) => {
  const { isLoading, startLoading, stopLoading } = useLoading();

  const handleSubmit = async (values: SubmitValues) => {
    startLoading();
    const { email } = values;
    if (email) {
      try {
        const response = await http.getVerificationCode(
          {
            email,
          },
          PARENT_URL.BASE_SERVER
        );
        const { message } = response || {};
        if (
          message &&
          message === 'Email Verification code sent successfully'
        ) {
          updateFields({ email });
          nextStep();
        } else {
          toast.error('Email verification failed');
        }
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          toast.error('Something went wrong, please try again later!!');
        }
      } finally {
        stopLoading();
      }
    }
  };

  return (
    <>
      <AuthContainer>
        <OnboardingHeaderWrapper
          title="Please enter your email address"
          index={0}
          link="LOGIN"
        />
        <Formik
          onSubmit={handleSubmit}
          initialValues={{
            email: '',
          }}
          validationSchema={enterEmailValidationSchema}
          enableReinitialize
        >
          {({
            values,
            touched,
            errors,
            isValid,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <TextInput
                label="Email"
                variant="normal"
                type="text"
                className="mb-3"
                placeHolder="Enter Email"
                htmlLabelFor="email"
                validState={
                  touched.email && errors.email
                    ? 'inValid'
                    : touched.email
                    ? 'valid'
                    : undefined
                }
                value={values.email}
                helperMessage={errors.email}
                onChange={handleChange}
                onBlur={handleBlur}
                isClear={false}
              />
              <p className="text-slate-500 text-[13px] font-medium font-SFProDisplay leading-[18px]">
                We will send you a quick email to confirm your address
              </p>
              <Button
                variant="normal"
                size="sm"
                label="Continue"
                className="block w-full mx-0 mt-8 md:mt-20"
                type="submit"
                disabled={
                  !isValid ||
                  Object.keys(errors).length > 0 ||
                  values?.email?.trim() === ''
                }
                isLoading={isLoading}
              />
            </form>
          )}
        </Formik>
      </AuthContainer>
    </>
  );
};
export default EnterEmail;
